export default __webpack_public_path__ + "static/media/l6.1df83d06.jpg";